<template>
    <v-ons-page>
        <!-- Toolbar -->
        <ons-toolbar class="main-toolbar">
            <div class="left">&nbsp;</div>
            <div class="center brand-toobar">
                <img src="/logo_v2.png" class="logo">
            </div>
            <div class="right">
                <ons-toolbar-button>
                    <router-link v-bind:to="{ name: 'Menu', params: { outlet_slug: embed.outlet_slug }}" v-bind:title="'Menu'" v-if="embed.enabled">
                        <i class="fal fa-times"/>
                    </router-link>
                    <router-link v-bind:to="{ name: 'Outlets' }" v-bind:title="'Outlets'" v-else>
                        <i class="fal fa-times"/>
                    </router-link>
                </ons-toolbar-button>
            </div>
        </ons-toolbar>

        <div class="content">
            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <div class="content-inner" v-if="view_order != null">

                <div class="verification-container" v-if="view_order.user && view_order.user.verified == false" data-test-id="cnt-verify-prompt">
                    <span v-show="view_order.user.is_guest == false">
                        Please verify your account using the link emailed to you to continue creating orders.
                    </span>
                    <span v-show="view_order.user.is_guest">
                        Please complete your account using the link emailed to you to gain the benefits of a full account.
                    </span>
                    <span class="link-button txt-verification-resend" v-on:click="resendVerificationEmail">I haven't received my email</span>
                </div>

                <div class="order-state-animation-container">
                    <img class="order-state-animation" :src="order_state_image">
                </div>
                <br>
                <template>

                    <div class="status-container">
                        <span class="status-container-header">
                            {{ title }}
                            <span v-if="helpers.stringEmpty(view_order.status.non_completion_reason) == false" class="status-container-reason">
                                {{ view_order.status.non_completion_reason }}
                            </span>
                        </span>
                        <template v-if="order_position != null">
                            <span class="status-container-number">
                                <span class="cyan-letter">{{ order_position }}</span>/{{ Object.values(order_positions_visible).length }}
                            </span>
                        </template>
                    </div>
                    <div>
                        <span class="status-container-subtitle">
                            <i aria-hidden="true" class="fa fa-clock status-container-icon"/>
                            <template v-if="order_position != null">
                                Updated {{ filters.dateRelative(view_order.status.last_updated) }}
                            </template>
                            <template v-else>
                                Updated {{ filters.date(view_order.status.last_updated) }}
                            </template>
                        </span>
                    </div>
                    <br>

                    <!-- Check if the status is a terminal status (Completed, Rejected, Cancelled) -->
                    <div class="progression-container" v-if="order_position !== null">
                        <div class="state-container">
                            <div class="state-entry" v-for="position in order_positions_visible" v-bind:class="{ active: position.active }">
                                <div class="state-entry-block"></div>
                                <div class="state-entry-text">{{ position.name }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="container-shadow"></div>

                    <br><br>

                    <!-- Order Information -->
                    <v-ons-list class="section-h">
                        <!-- Order -->
                        <div class="main-header">Order</div>
                        <v-ons-list-item v-if="view_order.sale_group" modifier="chevron" tappable
                            v-on:click="$router.push({ name: 'MultiOrder', params: { sale_group_id: view_order.sale_group.id } })">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Multi-order</div>
                                    <div class="list-item-content">
                                        This order is part of a {{ view_order.sale_group.order_count }} part
                                        multi-order from {{ view_order.sale_group.outlet.store_display_name }}
                                    </div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Placed</div>
                                    <div class="list-item-content">{{ filters.dateFormat(view_order.sales_date_time, 'DATETIME') }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-if="view_order.meta.requested_at">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class=" list-item-subheading">Requested</div>
                                    <div class=" list-item-content">{{ filters.dateFormat(view_order.meta.requested_at, view_order.meta.requested_at_datetime_format) }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-if="view_order.meta.requested_at">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class=" list-item-subheading">Expected</div>
                                    <div class=" list-item-content">
                                        <template v-if="view_order.status.expected_at">
                                            {{ filters.dateFormat(view_order.status.expected_at) }}
                                        </template>
                                        <template v-else>Waiting for confirmation</template>
                                    </div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Order type</div>
                                    <div class="list-item-content">{{ view_order.meta.fulfillment_type_name }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-if="view_order.meta.collection_point_name != null">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">{{ view_order.meta.fulfillment_type_name }} point</div>
                                    <div class="list-item-content">
                                        <div>
                                            <span>{{ view_order.meta.collection_point_name }}</span>
                                            <template v-if="helpers.stringEmpty(view_order.meta.collection_point_description) == false">
                                                <br>
                                                <small class="line-breaks">{{ view_order.meta.collection_point_description }}</small>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-if="view_order.address != null">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Delivery address</div>
                                    <div class="list-item-content">
                                        {{ view_order.address.address_lines.join(', ') }}
                                        <template v-if="helpers.stringEmpty(view_order.address.notes) == false">
                                            <br>
                                            <small class="line-breaks">{{ view_order.address.notes }}</small>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-if="view_order.table_cover">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Party size</div>
                                    <div class="list-item-content">{{ view_order.table_cover }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Order notes</div>
                                    <div class="list-item-content" data-test-id="txt-notes">
                                        <template v-if="view_order.notes && view_order.notes.length > 0">
                                            {{ view_order.notes }}
                                        </template>
                                        <template v-else>
                                            <span class="empty-text">Not provided</span>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </v-ons-list-item>
                    </v-ons-list>

                    <!-- Basket -->
                    <v-ons-list class="section-h">
                        <div class="main-header">Basket</div>
                        <template v-for="(item) in view_order.items">
                            <v-ons-list-item :key="item.product_id">
                                <div class="center">
                                    {{ item.quantity }}x {{ item.product_name }}
                                    <span v-if="item.item_notes"
                                        class="list-item__subtitle line-breaks list-item-subheading">{{ item.item_notes }}</span>
                                </div>
                                <div class="right">
                                    <span class="item-price-text">{{ filters.money(item.price, true, view_order.billing.currency_symbol) }}</span>
                                </div>
                            </v-ons-list-item>
                        </template>
                    </v-ons-list>

                    <!-- Payment -->
                    <v-ons-list class="section-h" data-test-id="cnt-payments">
                        <div class="main-header">Payment</div>
                        <template>
                            <v-ons-list-item v-show="view_order.billing.total != view_order.billing.subtotal">
                                <div class="center">Subtotal</div>
                                <div class="right">
                                    <span class="">
                                        {{ filters.money(view_order.billing.subtotal, true, view_order.billing.currency_symbol) }}
                                    </span>
                                </div>
                            </v-ons-list-item>
                        </template>
                        <template v-for="(charge,key) in view_order.billing.charges">
                            <v-ons-list-item v-show="parseFloat(charge.amount) > 0">
                                <div class="center">{{ charge.name }}</div>
                                <div class="right">
                                    <span class="">
                                        {{ filters.money(charge.amount, true, view_order.billing.currency_symbol) }}
                                    </span>
                                </div>
                            </v-ons-list-item>
                        </template>
                        <v-ons-list-item v-show="show_tips">
                            <div class="center">{{ view_order.billing.tips_label }}</div>
                            <div class="right">{{ filters.money(view_order.billing.sales_tips, true, view_order.billing.currency_symbol) }}</div>
                        </v-ons-list-item>
                        <v-ons-list-item>
                            <div class="center list-item">Total</div>
                            <div class="right">
                                <span class="item-price-text">
                                    <strong>{{ filters.money(view_order.billing.total, true, view_order.billing.currency_symbol) }}</strong>
                                </span>
                            </div>
                        </v-ons-list-item>
                        <div v-for="payment in view_order.billing.payments" v-bind:key="payment.id">
                            <v-ons-list-item>
                                <div class="center list-item">
                                    {{ payment.payment_method_name }}
                                    <span v-for="(card_details, index) in payment.card_details" :key="index"
                                          v-if="getCardDetailsList(card_details).length > 0 && payment.payment_method_name == 'Card'">
                                        &nbsp;({{ getCardDetailsList(card_details).join(' - ') }})
                                    </span>
                                </div>
                                <div class="right">{{ filters.money(getPaymentAmount(payment), true, view_order.billing.currency_symbol) }}</div>
                            </v-ons-list-item>
                            <v-ons-list-item v-for="refund in payment.payment_refunds" :key="refund.id"
                                             modifier="chevron" @click="showRefund(refund)">
                                <div class="center">
                                    Refund
                                </div>
                                <div class="right">{{ filters.money(-refund.amount, true, view_order.billing.currency_symbol) }}</div>
                            </v-ons-list-item>
                        </div>
                        <v-ons-list-item v-if="view_order.billing.payment_due > 0">
                            <div class="center">Payment due</div>
                            <div class="right">
                                <strong>{{ filters.money(view_order.billing.payment_due, true, view_order.billing.currency_symbol) }}</strong>
                            </div>
                        </v-ons-list-item>
                    </v-ons-list>

                    <!-- Store -->
                    <v-ons-list class="section-h">
                        <div class="main-header">Store</div>
                        <v-ons-list-item modifier="chevron" tappable
                                 v-on:click="$router.push({ name: 'Menu', params: { outlet_slug: view_order.outlet.slug } })">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Store</div>
                                    <div class="list-item-content">{{ view_order.outlet.store_display_name }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item modifier="chevron" tappable v-if="helpers.stringEmpty(view_order.outlet.phone_no) == false"
                                        v-on:click="app.openPhone(view_order.outlet.phone_no)">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Phone</div>
                                    <div class="list-item-content">{{ view_order.outlet.phone_no }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item modifier="chevron" tappable v-if="helpers.stringEmpty(view_order.outlet.contact_email) == false"
                                        v-on:click="app.openEmail(view_order.outlet.contact_email)">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Email</div>
                                    <div class="list-item-content">{{ view_order.outlet.contact_email }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item modifier="chevron" tappable v-on:click="app.openMap(view_order.outlet.address_lines)">
                            <div class="center">
                                <div class="list-item-stacked">
                                    <div class="list-item-subheading">Address</div>
                                    <div class="list-item-content">{{ view_order.outlet.address_lines.join(', ') }}</div>
                                </div>
                            </div>
                        </v-ons-list-item>
                    </v-ons-list>

                    <!-- Vouchers -->
                    <v-ons-list class="section-h" v-show="view_order.voucher_count > 0">
                        <div class="main-header">{{ filters.pluralise(2, view_order.voucher_name) }}</div>
                        <v-ons-list-item v-if="view_order.vouchers_confirmed == false">
                            <div class="center">
                                Your {{ filters.pluralise(view_order.voucher_count, view_order.voucher_name).toLowerCase() }} will emailed to you when the store completes the order.
                            </div>
                        </v-ons-list-item>
                        <v-ons-list-item v-else>
                            <div class="center">
                                Your {{ filters.pluralise(view_order.voucher_count, view_order.voucher_name).toLowerCase() }} have been emailed to you.
                            </div>
                        </v-ons-list-item>
                    </v-ons-list>

                    <!-- Order again button -->
                    <gtc-button class="primary btn-order-again" v-on:click="reorder" v-if="user" data-test-id="btn-reorder">
                        Order again
                    </gtc-button>

                    <!-- Footer loyalty box -->
                    <div class="section-h order-box-container loyalty-box" v-show="view_order.loyalty.points_earned">
                        <div class="loyalty-box-inner">
                            <a v-bind:href="goodies_link_platform">
                                <img src="/goodies_icon.png">
                            </a>
                            <div>
                                <p>You earned <strong>{{ view_order.loyalty.points_earned }}</strong> points from this order.</p>
                                <p>Get our Goodies app to check your balance and see which rewards are available to redeem in store.</p>
                            </div>
                        </div>
                        <a v-show="helpers.isiOS() || (helpers.isiOS() == false && helpers.isAndroid() == false)"
                           v-bind:href="goodies_link.ios" class="loyalty-box-app-link-appstore">
                            <img v-bind:href="goodies_link.ios" class="loyalty-box-app-link" src="/badge_appstore.svg">
                        </a>
                        <a v-show="helpers.isAndroid() || (helpers.isiOS() == false && helpers.isAndroid() == false)"
                           v-bind:href="goodies_link.android" class="loyalty-box-app-link-playstore">
                            <img v-bind:href="goodies_link.android" class="loyalty-box-app-link" src="/badge_playstore.png">
                        </a>
                        <p>
                            Please sign in with the email
                            <strong v-if="user">{{ user.email }}</strong>
                            <span v-else>you signed up with when placing the order</span>
                            to ensure your points are registered.
                        </p>
                    </div>

                </template>
            </div>
        </div>

        <v-ons-alert-dialog
                v-if="refund.data"
                title="Refund details"
                v-bind:visible.sync="refund.show"
                v-bind:footer="{
                    Close: () => refund.show = false,
                    'More info': () => app.openLink(refund.data.info.link),
                }">
            <div class="section-h">
                <div class="sub-header">Amount</div>
                {{ filters.money(refund.data.amount, true, view_order.billing.currency_symbol) }}
            </div>
            <div class="section-h">
                <div class="sub-header">Date requested</div>
                {{ filters.date(refund.data.created_at) }}
            </div>
            <div class="section-h" v-show="helpers.stringEmpty(refund.data.reason) == false">
                <div class="sub-header">Reason</div>
                {{ refund.data.reason }}
            </div>
            <div class="section-h" v-if="refund.data.info != null">
                <div class="sub-header">Refund process</div>
                {{ refund.data.info.message }}
            </div>
        </v-ons-alert-dialog>

        <v-ons-alert-dialog
                data-test-id="dlg-order-restored"
                v-bind:visible.sync="show_order_restored_dlg"
                v-bind:footer="{
                    Close: () => this.show_order_restored_dlg = false,
                }"
                title="Restored order">
            <div class="section-h">
                Showing the details for your last order which was interrupted during checkout.
            </div>
        </v-ons-alert-dialog>

    </v-ons-page>

</template>

<script>
    import { mapGetters, mapMutations, mapActions } from 'vuex'

    export default {

        props: ['in_flight'],

        components : {

        },

        created() {

        },

        mounted() {

            this.app.http.get(`order/${this.$route.params.sales_id}`)
                .then(response => {
                    this.view_order = response.data.order

                    if (this.$route.params.reorder_on_load) {
                        this.reorder()
                    }

                    if (this.$route.params.in_flight) {
                        this.show_order_restored_dlg = true
                    }

                    if (this.view_order.status.is_complete == false) {
                        this.update_timer = setInterval(() => {
                            this.update()
                        }, 10 * 1000)
                    }
                })
                .catch(error => {
                    this.$ons.notification.alert(
                        this.app.getResponseErrorMessage(error),
                        { title: 'Unable to display order' }
                    )
                    .then(() => this.$router.push(this.app.homeRoute()))
                })
        },

        beforeDestroy(){
            if (this.update_timer) {
                clearInterval(this.update_timer)
                this.update_timer = null
            }
        },

        data() {
            return {
                app: this.$root.$data.app,
                view_order: null,
                show_order_restored_dlg: false,
                update_timer: null,
                goodies_link: {
                    ios: 'https://itunes.apple.com/us/app/goodies/id1434560257',
                    android: 'https://play.google.com/store/apps/details?id=com.thegoodtill.loyalty'
                },
                loading_reorder: false,
                order_states: {
                    'COLLECTION': [
                        {
                            id: 'CREATED',
                            name: 'Created',
                            visible: true,
                        },
                        {
                            id: 'ACCEPTED',
                            name: 'Accepted',
                            visible: true,
                        },
                        {
                            id: 'READY',
                            name: 'Ready',
                            visible: true,
                        },
                        {
                            id: 'COMPLETED',
                            name: 'Completed',
                            visible: false,
                        },
                    ],
                    'DELIVERY': [
                        {
                            id: 'CREATED',
                            name: 'Created',
                            visible: true,
                        },
                        {
                            id: 'ACCEPTED',
                            name: 'Accepted',
                            visible: true,
                        },
                        {
                            id: 'DISPATCHED',
                            name: 'Dispatched',
                            visible: true,
                        },
                        {
                            id: 'COMPLETED',
                            name: 'Completed',
                            visible: false,
                        },
                    ],
                    'DROPOFF': [
                        {
                            id: 'CREATED',
                            name: 'Created',
                            visible: true,
                        },
                        {
                            id: 'ACCEPTED',
                            name: 'Accepted',
                            visible: true,
                        },
                        {
                            id: 'READY',
                            name: 'Ready',
                            visible: true,
                        },
                        {
                            id: 'COMPLETED',
                            name: 'Completed',
                            visible: false,
                        },
                    ],
                },
                refund: {
                    show: false,
                    data: null,
                },
            }
        },

        methods : {

            ...mapMutations([
                'clearOrder',
                'addProduct',
                'setOutlet',
                'setReorderSaleId',
            ]),

            ...mapActions([
                'refreshPromotions',
            ]),

            update() {

                const sale_id = this.$route.params.sales_id

                if (sale_id == null) {
                    return
                }

                this.app.http.get(`order/${sale_id}/status`)
                    .then(response => {
                        this.view_order.status = response.data.status
                    })
                    .catch(error => {

                    })
            },

            getPaymentAmount(payment){
                return parseFloat(payment.payment_amount) + parseFloat(payment.tips) 
            },

            getCardDetailsList(card_details) {

                const out = []

                if (this.view_order && this.view_order.billing.card && this.helpers.stringEmpty(this.view_order.billing.card.name) == false)
                    out.push(this.view_order.billing.card.name)

                if (card_details.card_brand)
                    out.push(card_details.card_brand)

                if (card_details.pan_last_digits)
                    out.push(card_details.pan_last_digits)

                if (card_details.entry_mode && card_details.entry_mode.toLowerCase() != 'card')
                    out.push(card_details.entry_mode)

                return out
            },

            showRefund(refund) {
                this.refund.data = refund
                this.refund.show = true
            },

            reorder(){
                // Get data
                this.loading_reorder = true

                this.app.http.get(`order/${this.$route.params.sales_id}/reorder`)
                    .then(response => {
                        const reorder_data = response.data

                        let next = () => {

                            this.app.analytics.track('reorder')

                            // Clear existing order
                            this.clearOrder()

                            let query = {
                                fulfillment_type: reorder_data.fulfillment_type,
                                display_layout_id: reorder_data.display_layout_id
                            }
                            this.app.http.get(`outlet/${reorder_data.previous_sale.outlet.slug}`, query)
                                .then(response => {

                                    this.loading_reorder = false

                                    // Set global outlet
                                    this.setOutlet(response.data.outlet)

                                    // Add products
                                    reorder_data.eligible_products.forEach(product => {
                                        this.addProduct({
                                            product: {
                                                image: product.image,
                                                product_id: product.product_id,
                                                product_name: product.product_name,
                                                selling_price: product.selling_price,
                                            },
                                            quantity: product.quantity,
                                            modifiers: product.modifiers.map(modifier => {
                                                return {
                                                    id: modifier.modifier_id,
                                                    name: modifier.modifier_name,
                                                    price: modifier.price,
                                                    quantity: modifier.quantity,
                                                }
                                            }),
                                            root_product_id: product.product_id,
                                            outlet: this.outlet,
                                        })
                                    })

                                    // Set reorder sale id
                                    this.setReorderSaleId(reorder_data.previous_sale.id)

                                    // Navigate to store page
                                    this.$router.push({
                                        name: 'Menu',
                                        params: {
                                            outlet_slug: reorder_data.previous_sale.outlet.slug,
                                            reorder: reorder_data,
                                        }
                                    })
                                })
                                .catch(error => {
                                    this.loading_reorder = false
                                    this.app.logException(new Error('Could not set outlet'), { error })
                                })
                        }

                        // Show error if 0 items available
                        if (reorder_data.eligible_products.length == 0) {
                            this.$ons.notification.alert(
                                'There are no items from the order that can be reordered automatically.',
                                { title: 'Unable to reorder' }
                            )
                            return
                        }

                        // If not embedded, ask before clearing the existing order
                        if (this.hasItems && this.order.form != null){
                            this.$ons.notification.confirm(
                                `There are currently ${this.itemCount} items in your existing order - continue and replace with reorder?`
                            )
                            .then(() => next())
                            .catch(error => console.log(error))
                        } else {
                            next()
                        }

                    })
                    .catch(error => {
                        this.loading_reorder = false

                        // Log if not an HTTP error
                        if (this.app.errorIsHttp(error) == false) {
                            this.app.logException(new Error('Re-order error.'), { error })
                        }

                        this.$ons.notification.alert(
                            this.app.getResponseErrorMessage(error),
                            { title: 'Unable to reorder' }
                        )
                    })
            },

            resendVerificationEmail(){
                return this.app.http.post('/user/verify/resend', { email: this.view_order.user.email })
                    .then(response => {
                        this.$ons.notification.alert(
                            response.data.message,
                            { title: 'Account verification' }
                        )
                    })
                    .catch(error => {
                        this.$ons.notification.alert(
                            this.app.getResponseErrorMessage(error),
                            { title: 'Account verification' }
                        )
                    })
            },
        },

        computed: {

            ...mapGetters([
                'embed',
                'user',
                'order',
                'outlet',
                'itemCount',
                'hasItems',
            ]),

            show_tips: function(){
                return parseFloat(this.view_order.billing.sales_tips) > 0
            },


            show_loading: function(){
                return this.view_order == null || this.loading_reorder
            },

            title: function(){

                if (this.view_order == null)
                    return ''

                return `Order #${this.view_order.order_ref} - ${this.view_order.status.status}`
            },

            goodies_link_platform: function(){

                if (this.helpers.isiOS())
                    return this.goodies_link.ios

                else if (this.helpers.isAndroid())
                    return this.goodies_link.android

                return null
            },

            order_positions: function() {

                if (this.view_order == null)
                    return null

                // Get states for fulfilment type
                let fulfilment_type_states = this.order_states[this.view_order.meta.fulfillment_type]

                // Generate output data
                let out_states = fulfilment_type_states.map((state, index) => {
                    state.index = index + 1
                    state.active = false
                    return state
                })

                // Get index of current state
                let current_state_index = fulfilment_type_states.map(s => s.name).indexOf(this.view_order.status.status)

                // If the current state is a user-visible state, set all states up to and including this state as active
                if (current_state_index > -1)
                    out_states = out_states.map(state => {
                        state.active = state.index <= current_state_index + 1
                        return state
                    })

                return out_states
            },

            order_positions_visible: function() {

                return this.order_positions.filter(state => state.visible)
            },

            order_position: function() {

                const last_active_state = this.order_positions_visible.slice().reverse().find(state => state.active)

                if (last_active_state)
                    return last_active_state.index

                return null
            },

            order_state_image: function() {

                const state_images = ['Accepted', 'Cancelled', 'Completed', 'Created', 'Dispatched', 'Ready', 'Rejected']
                if (state_images.includes(this.view_order.status.status))
                    return `/gifs/order/Order${this.view_order.status.status}.gif`

                return null
            }
        },
    }
</script>

<style scoped>
    ons-progress-bar {
        position: fixed;
        z-index: 99;
        width: 100%;
    }

    .order-state-animation {
        width: 300px;
        margin: 0 auto;
        display: block;
    }

    .cyan-letter {
        color: #62D6B6;
    }

    .list-item {
        font-style: normal;
        font-size: 16px;
        line-height: 20px;
        color: #181D1E;
    }

    .tick-icon {
        position: absolute;
        left: 25px;
        top: 12px;
        z-index: 1;
    }

    .list-item-subheading {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 20px;
        color: #4B4C4C;
        mix-blend-mode: normal;
        opacity: 0.5;
    }

    .list-item-content {
        font-style: normal;
        font-size: 16px;
        line-height: 20px;
        color: #181D1E;
    }

    .container-shadow {
        position: absolute;
        width: 100%;
        height: 20px;
        left: 0px;
        z-index: 1;
        background: white;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.05);
    }

    .btn-order-again {
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .state-container {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

    .state-entry {
        height: 100%;
        flex-grow: 1;
        margin-left: 5%;
        margin-right: 5%;
        text-align: center;
    }

    .state-entry-block {
        height: 10px;
        background-color: #E1E1E1;
        border-radius: 20px;
    }

    .state-entry.active .state-entry-block {
        background-color: var(--global-goodtill-green);
    }

    .state-entry-text {
        margin-top: 10px;
    }

    .order-box-container {
        background-color: rgb(225, 225, 225);
        color: rgb(24, 29, 30);
        border-radius: 10px;
        max-width: var(--global-btn-max-width);
        margin: 20px auto;
        padding: 20px;
        text-align: center;
    }

    .status-container .status-container-header {
        height: 20px;
        left: 8%;
        right: 28%;
        top: 414px;
        width: 100%;
        z-index: 1;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        letter-spacing: -0.02em;
        color: #181D1E;
    }

    .status-container .status-container-number {
        height: 20px;
        z-index: 1;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 20px;
        text-align: right;
        letter-spacing: -0.02em;
        float: right;
        color: #E1E1E1;
    }

    .status-container-subtitle {
        z-index: 1;

        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;

        color: rgba(24, 29, 30, 0.5);  
    }

    .status-container .status-container-reason {
        display: block;
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .status-container-icon {
        color: var(--global-goodtill-green);
    }

    .loyalty-box-inner {
        display: flex;
    }

    .loyalty-box-inner img {
        height: 100px;
        width: 100px;
        border-radius: 20px;
        margin-right: 15px;
        margin-top: 15px;
    }

    .loyalty-box-inner p {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    .loyalty-box-app-link {
        width: 70%;
        display: block;
        margin: 0 auto;
    }

    .loyalty-box-app-link-appstore {
        display: block;
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;
    }

    .verification-container {
        border: 1px var(--global-goodtill-green) solid;
        padding: 3px;
        border-radius: var(--global-border-radius);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .verification-container .txt-verification-resend {
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/user/order.vue